export default {
      id: "medicines-usage",
      viewBox: "0 0 19 24",
      url: __webpack_public_path__ + "img/icons.svg#medicines",
      toString: function () {
        return this.url;
      }
    }